import { Component } from '@angular/core';
import { CurrentFeaturesComponent } from './current-features/current-features.component';
import { FutureReleasesComponent } from './future-releases/future-releases.component';
import { SubHeaderComponent } from '@components/sub-header/sub-header.component';

@Component({
  standalone: true,
  selector: 'home-page',
  imports: [CurrentFeaturesComponent, FutureReleasesComponent, SubHeaderComponent],
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.scss',
})
export class HomePageComponent {
  imagePath = 'assets/home-page-banner.png';
}
